// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.signature[data-v-252779d0] {\n    height: 100px;\n    overflow: auto;\n    font-size: 0.75em;\n    line-break: anywhere;\n}\n.sign-text[data-v-252779d0] {\n    white-space: pre-line;\n}\n", ""]);
// Exports
module.exports = exports;
